import React from "react";
import styled, { css } from "styled-components";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { colors } from "../../utils";
import TextView from "../TextView";

const CustomSelect = styled(Select)`
  width: 100%;
  background-color: ${({ variant }) =>
    variant === "outlined" ? "white" : colors.background};
  border-radius: 8px;
  height: 36px;
  outline: none;
  padding: 0px;
  margin-top: 5px;
  cursor: pointer;

  .MuiSelect-select {
    padding: 5px 10px !important;
    font-size: 12px !important;
    border-radius: 8px !important;
  }
`;

const CustomMenuItem = styled(MenuItem)`
  margin-bottom: 8px !important;

  &.MuiListItem-root {
    padding: 8px;
  }

  &.Mui-selected {
    background-color: #efe9fe !important;
    border-radius: 8px;
    padding-top: 8px;
    padding-bottom: "8px";
  }
`;

const CustomMenuProps = {
  PaperProps: {
    style: {
      width: "180px",
      display: "flex",
      flexDirection: "column",
      borderRadius: "8px",
      padding: "16px",
      gap: "8px",
      boxShadow: "0px 0px 9.3px 0px #3B3B3B1C"
    },
  },
};

export default function Dropdown({
  labelVariant,
  options = [],
  label,
  labelStyle,
  variant = "standard",
  subLabel,
  renderValue,
  containerStyle,
  handleForceChange,
  ...rest
}) {
  return (
    <div style={containerStyle}>
      {label ? (
        <TextView variant={labelVariant} style={labelStyle}>
          {label}
        </TextView>
      ) : null}
      {subLabel ? <TextView style={{margin:"5px 0px"}}>{subLabel}</TextView>:null}
      <CustomSelect
        placeholder="Select a gender"
        variant={variant}
        defaultValue={options[0]?.value}
        disableUnderline
        MenuProps={CustomMenuProps}
        renderValue={renderValue}
        {...rest}
      >
        {options.map((option) => (
          <CustomMenuItem key={option?.value} value={option?.value} onClick={option.value === "date" ? handleForceChange : undefined}>
            {option?.label}
          </CustomMenuItem>
        ))}
      </CustomSelect>
    </div>
  );
}
